import { render, staticRenderFns } from "./BancoDeCartasICEditar.vue?vue&type=template&id=1ab78462"
import script from "./BancoDeCartasICEditar.vue?vue&type=script&lang=js"
export * from "./BancoDeCartasICEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports